import React from 'react';
import PropTypes from 'prop-types';
import './GoToLink.css';

const GoToLink = ({
    id,
    children,
    type,
    clasName,
    uuid,
    title,
    extraParams,
    useTarget,
    linkStyle,
    contentType,
    color
}) => {
    const buildSearchParameter = () => {
        switch(type) {
            case 'celebrity':
                return `/manager/index.php?r=CelebrityBuilder/index&celebId=${id}`;
            case 'product':
                return `/manager/index.php?r=productbuilder/index&productId=${id}`;
            case 'productCostComponent':
                return `/manager/index.php?r=dashboard/ccdetails&productId=${id}`;
            case 'copywriter':
                return `/manager/index.php?r=copywriter/index&id=${id}&${extraParams}`;
            case 'charity':
                return `/manager/index.php?r=charityBuilder/index&charityId=${id}`;    
            case 'dashboard':
                return `/manager/index.php?r=dashboard/index`;
            case 'contentbuilder':
                return '/manager/index.php?r=dashboard/contentbuilder';
            default:
                return type;
        };
    };

    const titleToUse = title || `This link opens ${children} on the same window`;
    const classToUse = linkStyle === 'btn' ? `${SG.BG_PRIMARY} ${SG.BTN_PRIMARY} ${SG.C_3} ${SG.HOVER_1} ${SG.BTN} ${SG.F_BUTTON}` : '';
    const typeContent = contentType ? `type-${content}` : '';
    const colorStyle = color ? { 'font-color': color } : {};
    return (
        <a
            id          = {uuid}
            title       = {titleToUse}
            className={`${clasName} go-${linkStyle} ${classToUse} ${typeContent}`}
            href        = {buildSearchParameter()}
            uuid        = {uuid}
            target      = {useTarget}
            style       = {colorStyle}
        >
            {children}
        </a>
    );
};

GoToLink.defaultProps = {
    clasName:    '',
    extraParams: null,
    title:       null,
    useTarget:   '_self',
    linkStyle:   'link',
    contentType: false,
    color:       null
  };

  GoToLink.propTypes = {
    // Id used for the link
    id: PropTypes.string.isRequired,
    // For automation, analytics
    uuid: PropTypes.string.isRequired,
    // Name to display in the link
    children: PropTypes.string.isRequired,
    // Type of page to navgate to Ex: Celebrity Details
    // Or link
    type: PropTypes.string.isRequired,
    // Any custom CSS class
    clasName: PropTypes.string,
    // ADA Compliance
    title: PropTypes.string,
    // Extra Params for the Link
    extraParams: PropTypes.string,
    // Link Target
    useTarget: PropTypes.string,
    // To override style to be button
    linkStyle: PropTypes.oneOf([
        'btn',
        'link'
    ]),
    // To override style to be button
    contentType: PropTypes.bool,
    // Font color
    color: PropTypes.string
};

export default GoToLink;
